<template>
  <el-select
    v-model="model.customer"
    filterable
    remote
    reserve-keyword
    :disabled="disabled"
    clearable
    value-key="id"
    :remote-method="fetchSearchedCustomers"
    :loading="loading"
    :placeholder="$t('common.select.placeholder')"
    @change="selectCustomer">
    <el-option
      v-for="customer in searchedCustomers"
      :key="customer.id"
      :label="customerName(customer)"
      :value="customer">
      <i v-if="customer.company==null" class="mdi mdi-account-circle align-vertical-middle"></i>
      <i v-else class="mdi mdi-city align-vertical-middle"></i>
      <span style="margin-left:5px; color: #8492a6; font-size: 13px">{{ customerName(customer) }}</span>
    </el-option>
  </el-select>
</template>
<script>
import customerApi from '@/services/API/customer'
import { mapActions, mapState, mapGetters } from 'vuex';
export default {
    name: 'SelectCustomer',
  props: {
        customer : {
      type : Object
    },
    active : {
      type : Boolean,
      default : true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    selected : {
      type: Boolean,
      default: true
    }
    },
    data() {
        return {
      model : {
        customer : null
      },
      searchedCustomers : [],
      loading : false
       }
   },
  computed: {
    ...mapGetters('customers',['customerName']),
  },
  components : {
  },
  methods : {
    selectCustomer(customer){
      this.$emit('selected', customer);
      if (!this.selected) {
        this.model.customer = null;
      }
    },
    fetchSearchedCustomers(query){
      this.loading = true;
      return customerApi.fetchSearchedCustomers({searchTerms:query,paging:'no', active:this.active})
      .then(searchedCustomers => {
        this.searchedCustomers = searchedCustomers;
        this.loading = false;
      });
    },
    getCustomerByCustomerId(customerId){
      return customerApi.getCustomer(customerId)
    }
  },
  watch: {
    customer: function(newCustomer, oldCustomer) {
      if (newCustomer == null) {
        this.model.customer = null;
        this.searchedCustomers = [];
      } else {
        this.searchedCustomers = [newCustomer];
        this.model.customer = newCustomer;
      }

    }
  },
  created(){
    if(this.customer!=null){
      this.getCustomerByCustomerId(this.customer.id)
        .then(customer=>{
          this.searchedCustomers.push(customer);
          this.model.customer = customer;
          this.selectCustomer(customer)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables';
.el-scrollbar {
  > .el-scrollbar__bar {
    opacity: 1;
  }
}
</style>